export default function () {
  this.getTotalAgendasActives()
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/statistics/resources/mounted.js